export default __webpack_public_path__ + "static/media/basket.c83ec1f2.svg";